import dynamic from 'next/dynamic';
const IntegrationCardBoard = dynamic(() => import('./IntegrationCardBoard'));
export default IntegrationCardBoard;
